import { useTranslation } from "react-i18next"

import ButtonComponent from "../../../../Components/Button"
import Icon from "../../../../Icon"

function InviteUserButton({ isMobile, isDisabled, onOpen }) {
  const { t } = useTranslation()

  const handleClick = () => {
    if (isDisabled) return
    onOpen()
  }

  if (isMobile) {
    return (
      <ButtonComponent
        icon={<Icon type="user_add" />}
        onClick={handleClick}
        disabled={isDisabled}
        style={{ width: 40, height: 40, padding: 0 }}
      />
    )
  }

  return (
    <ButtonComponent
      size="large"
      icon={<Icon type="user_add" />}
      text={t("Invite user")}
      onClick={handleClick}
      disabled={isDisabled}
    />
  )
}

export default InviteUserButton
